import React, { Dispatch, SetStateAction, createContext, ReactNode, useState, useContext } from "react";

export interface ISideBarContext {
    sideBarStatus : boolean,
    setSideBarStatus : Dispatch<SetStateAction<boolean>>
}

const SideBarContext = createContext<ISideBarContext>({} as ISideBarContext);

type UserProvideProps = {
    children: ReactNode
}

const SideBarProvider : React.FC<UserProvideProps> = ({children}) => {

    const [sideBarStatus, setSideBarStatus] = useState<boolean>(true);

    return (
        <SideBarContext.Provider value={{sideBarStatus, setSideBarStatus}}>
            {children}
        </SideBarContext.Provider>
    )

}

function useSidebar(): ISideBarContext {
    const context = useContext(SideBarContext);

    return context;
}

export {SideBarProvider, useSidebar};